import { gql } from "lib/apolloClient";
import {
  commentConnectionFragment,
  commentNodeFragment,
} from "./RightPaneFragments";

export const StudentGoalItem = gql`
  fragment studentGoalItem on StudentGoal {
    id
    studentGoalComments: comments {
      ...commentConnectionItem
    }
  }
  ${commentConnectionFragment.commentConnection}
`;

export const getCommentOfNodeQuery = gql`
  query getCommentOfNode(
    $id: ID!
    $first: Int
    $after: String
    $type: ENTITY_TYPE_ENUM!
  ) {
    node(id: $id, type: $type) {
      ... on StudentGoal {
        ...studentGoalItem
      }

      ... on GoalTask {
        ...studentGoalTaskItem
      }
    }
  }
  ${StudentGoalItem}
  ${commentNodeFragment.studentGoalTask}
`;
